import React from 'react'
import { DatePicker, Radio } from 'antd'
import moment, { Moment } from 'moment'
import { useTranslation } from 'react-i18next'

const EXPIRY_PRESET_DAYS = [30, 90, 180, 365]

export type ExpirySelection =
  | { kind: 'preset'; days: number }
  | { kind: 'none' }
  | { kind: 'custom'; date: Moment | null }

export const resolveExpiresAt = (selection: ExpirySelection): string | null => {
  if (selection.kind === 'none') return null
  if (selection.kind === 'preset') {
    return new Date(
      Date.now() + selection.days * 24 * 60 * 60 * 1000,
    ).toISOString()
  }
  return selection.date ? selection.date.toISOString() : null
}

export const initialExpirySelection = (
  expiresAt?: string | null,
): ExpirySelection =>
  expiresAt ? { kind: 'custom', date: moment(expiresAt) } : { kind: 'none' }

interface Props {
  value: ExpirySelection
  onChange: (value: ExpirySelection) => void
}

export const ExpirySelector = ({ value, onChange }: Props) => {
  const { t } = useTranslation()
  const radioValue = value.kind === 'preset' ? value.days : value.kind

  const handleRadioChange = (evt: any) => {
    const picked = evt.target.value
    if (picked === 'none') onChange({ kind: 'none' })
    else if (picked === 'custom')
      onChange({
        kind: 'custom',
        date: value.kind === 'custom' ? value.date : null,
      })
    else onChange({ kind: 'preset', days: picked })
  }

  return (
    <div>
      <Radio.Group
        optionType="button"
        buttonStyle="solid"
        value={radioValue}
        onChange={handleRadioChange}
      >
        {EXPIRY_PRESET_DAYS.map(days => (
          <Radio.Button key={days} value={days}>
            {t('admin.akDays', { count: days })}
          </Radio.Button>
        ))}
        <Radio.Button value="none">{t('admin.akNoExpiry')}</Radio.Button>
        <Radio.Button value="custom">{t('admin.akCustomExpiry')}</Radio.Button>
      </Radio.Group>
      {value.kind === 'custom' && (
        <DatePicker
          showTime
          style={{ marginTop: '10px', width: '100%' }}
          value={value.date}
          onChange={date => onChange({ kind: 'custom', date })}
          disabledDate={current => !!current && current < moment().startOf('day')}
        />
      )}
    </div>
  )
}
